import React from 'react';
import { TextSizes } from '@/constants/TextSizes';
import { TextMarginBottom } from '@/constants/TextMarginBottom';
import { CardAvatar } from './CardAvatar';
import styles from './CardContent.module.scss';
import { Text } from '../Text';
import { Title } from '../Title';

type CardContentType = {
  authorName: string;
  authorImageSrc?: string;
  category: string;
  date: string;
  heading: string;
  isHero: boolean;
  isTileWithImage: boolean;
  imageSrc?: string;
  timeToRead: number;
};

export const CardContent = ({
  heading,
  isHero,
  isTileWithImage,
  date,
  authorImageSrc,
  authorName,
  category,
  timeToRead,
}: CardContentType) => (
  <div className={`${styles.root} ${isTileWithImage ? styles['tile-with-image-root'] : ''}`}>
    <div className={`${styles.category} ${isTileWithImage ? styles['tile-with-image-category'] : ''}`}>
      <Text>{category}</Text>
    </div>

    <Text
      style={{
        fontWeight: 600,
        marginTop: 16,
        color: '#4d515a',
      }}
      size={TextSizes.EXTRASMALL}
      marginBottom={TextMarginBottom.TINY}
    >
      <p>
        <strong>
          {new Date(date).toDateString()} |{timeToRead} min read
        </strong>
      </p>
    </Text>

    <div
      className={`${styles.heading} ${isHero ? styles['hero-heading'] : ''} ${
        isTileWithImage ? styles['tile-with-image-heading'] : ''
      }`}
    >
      <Title size={isHero ? 'l' : 's'}>{isHero ? <h1>{heading}</h1> : <p>{heading}</p>}</Title>
    </div>

    <CardAvatar
      {...{
        authorImageSrc,
        authorName,
        isTileWithImage,
        isHero,
      }}
    />
  </div>
);
